import { render, staticRenderFns } from "./ViewImagingResults.vue?vue&type=template&id=a5341f34&"
import script from "./ViewImagingResults.vue?vue&type=script&lang=js&"
export * from "./ViewImagingResults.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports